exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.reportTbl[data-v-c6e1c4c4]{width:100%;border-collapse:collapse}.reportTbl td[data-v-c6e1c4c4]{border:1px solid #ccc;padding:6px}.reportTbl tr td[data-v-c6e1c4c4]{text-align:left;line-height:12px}.txtRight[data-v-c6e1c4c4]{text-align:right!important}.reportTbl tr.txtCenter td[data-v-c6e1c4c4]{text-align:center}.reportTbl tr.tb-td td[data-v-c6e1c4c4]{font-weight:700;text-align:center;border:none}td.textCenter[data-v-c6e1c4c4]{text-align:center}td.textRight[data-v-c6e1c4c4]{text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c6e1c4c4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reportGenerate/pdf/quarterlyProgressReport.vue
// module id = 1604
// module chunks = 3